import childhoodIcon from './icons/memory_centered/01_childhood_童年_2048.png'
import familyIcon from './icons/memory_centered/02_family_家人_2048.png'
import friendsIcon from './icons/memory_centered/03_friends_朋友_2048.png'
import campusIcon from './icons/memory_centered/04_campus_校园_2048.png'
import teacherIcon from './icons/memory_centered/05_teacher_老师_2048.png'
import hometownIcon from './icons/memory_centered/06_hometown_家乡_2048.png'
import travelIcon from './icons/memory_centered/07_travel_旅行_2048.png'
import festivalIcon from './icons/memory_centered/08_festival_节日_2048.png'
import birthdayIcon from './icons/memory_centered/09_birthday_生日_2048.png'
import graduationIcon from './icons/memory_centered/10_graduation_毕业_2048.png'
import reunionIcon from './icons/memory_centered/11_reunion_重逢_2048.png'
import farewellIcon from './icons/memory_centered/12_farewell_离别_2048.png'
import firstTryIcon from './icons/memory_centered/13_first-try_初次尝试_2048.png'
import growthIcon from './icons/memory_centered/14_growth_成长时刻_2048.png'
import dreamIcon from './icons/memory_centered/15_dream_梦想_2048.png'
import holidayIcon from './icons/memory_centered/16_holiday_假期_2048.png'
import weekendIcon from './icons/memory_centered/17_weekend_周末_2048.png'
import summerIcon from './icons/memory_centered/18_summer_夏天_2048.png'
import rainyDayIcon from './icons/memory_centered/19_rainy-day_下雨天_2048.png'
import nightIcon from './icons/memory_centered/20_night_夜晚_2048.png'
import mealIcon from './icons/memory_centered/21_meal_一顿饭_2048.png'
import songIcon from './icons/memory_centered/22_song_一首歌_2048.png'
import photoIcon from './icons/memory_centered/23_photo_一张照片_2048.png'
import giftIcon from './icons/memory_centered/24_gift_一份礼物_2048.png'
import roadIcon from './icons/memory_centered/25_road_一段路_2048.png'
import oldPlaceIcon from './icons/memory_centered/26_old-place_一个老地方_2048.png'
import companionshipIcon from './icons/memory_centered/27_companionship_一次陪伴_2048.png'

const icons: Record<string, string> = {
  childhood: childhoodIcon,
  family: familyIcon,
  friends: friendsIcon,
  campus: campusIcon,
  teacher: teacherIcon,
  travel: travelIcon,
  festival: festivalIcon,
  hometown: hometownIcon,
  love: companionshipIcon,
  work: growthIcon,
  birthday: birthdayIcon,
  graduation: graduationIcon,
  reunion: reunionIcon,
  farewell: farewellIcon,
  'first-try': firstTryIcon,
  dream: dreamIcon,
  holiday: holidayIcon,
  weekend: weekendIcon,
  summer: summerIcon,
  'rainy-day': rainyDayIcon,
  night: nightIcon,
  meal: mealIcon,
  song: songIcon,
  photo: photoIcon,
  gift: giftIcon,
  road: roadIcon,
  'old-place': oldPlaceIcon,
  custom: photoIcon,
}

export function getMemoryIcon(code: string) {
  const lookupCode = code.startsWith('custom:') ? 'custom' : code
  return icons[lookupCode]
}
